<template>
  <div class="card card-default shadow">
    <div class="card-body">
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label>Subject</label>
            <select v-model="obj.TeacherID" class="form-control">
              <option value="0">All</option>
              <option v-for="item in courses" :value="item.TeacherCourseAllotmentID">{{item.CourseTitle}} - {{item.ClassName}}</option>
            </select>
          </div>
        </div>
        <div class="col-md-3">
          <label>Assessment Type</label>
          <select class="form-control" v-model="obj.AssessmentTypeID" required v-on:change="assessmentChange()">
            <option value="0" disabled="disabled">--Select Type</option>
            <option v-for="item in assessmentTypes" v-bind:value="item.AssessmentTypeID">{{item.Name}}</option>
          </select>
        </div>
        <div class="col-md-3">
          <label>Term</label>
          <select class="form-control" v-model="obj.TermID" required v-on:change="TermChange()">
            <option value="0" disabled="disabled">--Select Term</option>
            <option v-for="item in terms" v-bind:value="item.AssessmentTermID">{{item.Name}}</option>
          </select>
        </div>
        <div class="col-lg-3">
          <div class="form-group">
            <br />
            <button class="btn btn-sm btn-success" type="button" v-on:click="loadEvaluatedCoreSkills">Load</button>
          </div>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-md-12" v-for="c in courses2.filter(x=>x.TeacherCourseAllotmentID == (obj.TeacherID == 0 ? x.TeacherCourseAllotmentID : obj.TeacherID))">
          <label>{{c.CourseTitle}} - {{c.Teacher}}</label>
          <div class="table-responsive">
            <table class="table table-bordered table-sm ">
              <thead class="bg-custom">
                <tr>
                  <th class="col-question">Question</th>
                  <th style="width:100px" v-for="d in dates" class="col-date">{{d}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(q, ind) in questions.filter(x => x.SchemeOfStudyChildID == c.SchemeOfStudyChildID)">
                  <td>
                    <span style="font-weight:bold" v-if="q.SubCategory">{{q.SubCategory}}</span>
                    {{q.Question}}
                  </td>
                  <td v-for="d in dates" width="150px">
                    <span v-if="q.SubCategory != 'Specific Remarks'">{{getEvaluation(d, q.QuestionID, q.SubCategory)}}</span>
                    <small v-else>{{getEvaluation(d, q.QuestionID, q.SubCategory)}}</small>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  export default {
    name: 'result',
    data() {
      return {
        courses: [],
        courses2: [],
        results: [],
        assessmentTypes: [],
        terms: [],
        assessments: [],
        coreSkills: [],
        questions: [],
        dates: [],
        evaluations: [],
        obj: {
          TeacherID: 0,
          AssessmentTypeID: 0,
          TermID: 3,
        },
      }
    },
    created() {
      this.pageLoad();
    },
    updated() {
    },
    methods: {
      pageLoad() {
        var vm = this;
        const url = new URLSearchParams(window.location.search);
        vm.obj.TeacherID = Number(url.get("teacherID"));
        startReq();
        axios.post('/api/PortalApi/pageloadCourseSkill')
          .then(function (res) {
            endReq();
            vm.assessmentTypes = res.data.assessmentType;
            vm.terms = res.data.term;
            vm.courses = res.data.courses;
          })
          .catch((error) => {
            endReq();
            console.log(error);
          })
      },
      loadEvaluatedCoreSkills() {
        var vm = this;
        startReq();
        axios.post('/api/PortalApi/loadEvaluatedCoreSkills?teacherID=' + vm.obj.TeacherID + "&assessmentTypeID=" + vm.obj.AssessmentTypeID + "&TermID=" + vm.obj.TermID)
          .then(function (res) {
            endReq();
            var table = $('#tbl').DataTable();
            table.destroy();
            vm.dates = res.data.dates;
            vm.courses2 = res.data.courses;
            vm.questions = res.data.questions;
            vm.evaluations = res.data.evaluations;
          })
          .catch((error) => {
            console.log(error);
            endReq();
          })
      },

      getEvaluation(date, questionID, subCategory) {
        var o = this.evaluations.find(x => x.Date == date && x.QuestionID == questionID);
        if (o != null) {
          if (subCategory != 'Specific Remarks')
            return o.Option;
          else
            return o.Option
        }
        else
          return "";
      },

      dateColWidth() {
        return this.dates.length ? (47 / this.dates.length) + '%' : 'auto';
      },

      Print() {
        var url = new URLSearchParams(window.location.search);
        var id = url.get("teacherID")
        window.location.href = "/Portal/CourseResultPrint?teacherID=" + id;
      },

      getList() {
        var table = $('#tbl').DataTable();
        table.destroy();
        if (this.teacherID == 0)
          return this.results;
        else
          return this.results.filter((x) => { return x.TeacherCourseAllotmentID == this.teacherID });
      },
      assessmentChange() {
        this.assessments = [];
      },

      TermChange() {
        this.assessments = [];
      },
    },
  }
</script>
<style scoped>
  #tbl {
    table-layout: fixed;
    width: 100% !important;
  }

    #tbl .col-sr {
      width: 50px !important;
      text-align: center;
    }

    #tbl .col-date {
      width: 110px !important;
      white-space: nowrap;
    }

    #tbl .col-question {
      width: auto !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/school/LMS/CourseSkill.vue